import { useEffect, useState } from "react";
import {
  MessageSquareQuote,
  ClipboardList,
  Images,
  MapPin,
  Building2,
  Truck,
  Bot,
  Settings,
  Handshake,
} from "lucide-react";
import { adminStats } from "@/lib/api";

const CARDS = [
  { key: "reviews", label: "Reviews", icon: MessageSquareQuote, stat: "pending_reviews", statLabel: "Pending reviews" },
  { key: "bids", label: "Bid Requests", icon: ClipboardList, stat: "new_bids", statLabel: "New bid requests" },
  { key: "projects", label: "Projects / Gallery", icon: Images, stat: "published_projects", statLabel: "Published projects" },
  { key: "companies", label: "Companies We Work With", icon: Handshake, stat: null, statLabel: "" },
  { key: "areas", label: "Service Areas", icon: MapPin, stat: null, statLabel: "" },
  { key: "business", label: "Business Information", icon: Building2, stat: null, statLabel: "" },
  { key: "r3", label: "R3 Services", icon: Truck, stat: null, statLabel: "" },
  { key: "ai", label: "AI Assistant Settings", icon: Bot, stat: null, statLabel: "" },
  { key: "settings", label: "Settings", icon: Settings, stat: null, statLabel: "" },
];

export const DashboardHome = ({
  onNavigate,
  email,
}: {
  onNavigate: (tab: string) => void;
  email: string;
}) => {
  const [stats, setStats] = useState<any>(null);

  useEffect(() => {
    adminStats()
      .then((r) => setStats(r.data))
      .catch(() => setStats({}));
  }, []);

  return (
    <div data-testid="admin-dashboard-home">
      <p className="text-sm text-neutral-400">
        Signed in as <span className="font-bold text-white">{email}</span>
      </p>
      <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {CARDS.map((c) => {
          const Icon = c.icon;
          return (
            <button
              key={c.key}
              data-testid={`admin-card-${c.key}`}
              onClick={() => onNavigate(c.key === "r3" ? "business" : c.key)}
              className="group flex flex-col border border-white/10 bg-charcoal p-6 text-left transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="flex items-center justify-between">
                <Icon className="h-6 w-6 text-gold" strokeWidth={1.5} />
                {c.stat && stats && (
                  <span className="font-display text-3xl font-black text-white">
                    {stats[c.stat] ?? 0}
                  </span>
                )}
              </div>
              <p className="mt-6 font-display text-lg font-black uppercase tracking-tight text-white transition-colors duration-300 group-hover:text-gold">
                {c.label}
              </p>
              {c.statLabel && (
                <p className="mt-1 text-[11px] font-bold uppercase tracking-[0.15em] text-neutral-500">
                  {c.statLabel}
                </p>
              )}
              <span className="mt-auto block pt-5">
                <span className="block h-[2px] w-8 bg-gold transition-[width] duration-500 group-hover:w-full" />
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
